export const getAddinsActionControl = "cVd";
export const sensitivityActionControl = "dVd";
export const sensitivityLearnMoreActionControl = "eVd";
export const showLinkDialogActionControl = "fVd";
export const attachFileActionControl = "gVd";
export const attachSignatureActionControl = "hVd";
export const highImportanceActionControl = "iVd";
export const clpLabelDropDownLearnMoreActionControl = "jVd";
export const clpLabelDropDownLearnMoreToolTipTextActionControl = "kVd";
export const findTimeDescription = "lVd";
export const proofingOptionsDescription = "mVd";
export default {getAddinsActionControl,sensitivityActionControl,sensitivityLearnMoreActionControl,showLinkDialogActionControl,attachFileActionControl,attachSignatureActionControl,highImportanceActionControl,clpLabelDropDownLearnMoreActionControl,clpLabelDropDownLearnMoreToolTipTextActionControl,findTimeDescription,proofingOptionsDescription};